<template>
  <div id="app">
    <AppDefaultLayout />
  </div>
</template>

<script>
import AppDefaultLayout from '@/views/layouts/AppDefaultLayout.vue';

export default {
  components: {
    AppDefaultLayout,
  },

  created() {
    this.$store.dispatch('detectUserDevice');
    window.addEventListener('popstate', this.handlePopState);
  },

  beforeDestroy() {
    window.removeEventListener('popstate', this.handlePopState);
  },

  methods: {
    handlePopState() {
      this.$store.dispatch('setIsFiredPopStateEvent', true);
    },
  },
};
</script>

<style src="bootstrap/dist/css/bootstrap.css"></style>
<style src="swiper/css/swiper.css"></style>
<style src="@/assets/scss/style.scss" lang="scss"></style>
